const appReducerDefaultState = {
    adminApp: false,
    mainMenuOpen: false,
    accessibilityMenuOpen: false,
    pagerFullPageContextId: false,
    pagerFullPages: [],
    mainSettings: {},
    releaseState: {
      showDay: false,
      showDate: false
    },
    isMobile: true,
    timetableBreakpoint: false,
    menuTitle: false,
    hideSort: false,
    hideFilter: false,
    searchOpen: false,
    microSite: false,
    microSiteFrontPage: "",
    persistViewSwitch: false,
    isConferenceOverviewPage: false,
    isFestivalOverviewPage: false,
    overwriteFooter: false,
    customHistory: [
      {
        hash: "",
        key: "",
        pathname: "/",
        search: "",
        state: null
      }
    ],
    simpleDesign: true,
    panicScrollBlock: false,
    preventJumpToCurrentTime: false
  },
  appReducer = (state = appReducerDefaultState, action) => {
    switch (action.type) {
      case "ADMIN_APP": {
        return Object.assign({}, state, { adminApp: action.adminApp });
      }
      case "PAGER_FULL_PAGE": {
        // Remove if they are pushed twice (or after query finish).
        const pagerFullPages = state.pagerFullPages.filter(
          (config) => config.id !== action.config.id
        );
        return Object.assign({}, state, {
          pagerFullPages: [...pagerFullPages, action.config],
        });
      }
      case "PAGER_FULL_PAGE_CONTEXT_ID": {
        return Object.assign({}, state, { pagerFullPageContextId: action.id });
      }
      case "MAIN_MENU_OPEN": {
        return Object.assign({}, state, { mainMenuOpen: action.mainMenuOpen });
      }
      case "ACCESSIBILITY_MENU_OPEN": {
        return Object.assign({}, state, { accessibilityMenuOpen: action.accessibilityMenuOpen });
      }
      case "IS_MOBILE": {
        return Object.assign({}, state, { isMobile: action.isMobile });
      }
      case "TIMETABLE_BREAKPOINT": {
        return Object.assign({}, state, { timetableBreakpoint: action.timetableBreakpoint });
      }
      case "MAIN_SETTINGS": {
        return Object.assign({}, state, { mainSettings: action.mainSettings });
      }
      case "RELEASE_STATE": {
        return Object.assign({}, state, { releaseState: action.releaseState });
      }
      case "MENU_TITLE": {
        return Object.assign({}, state, { menuTitle: action.menuTitle });
      }
      case "HIDE_SORT": {
        return Object.assign({}, state, { hideSort: action.hideSort });
      }
      case "HIDE_FILTER": {
        return Object.assign({}, state, { hideFilter: action.hideFilter });
      }
      case "MICROSITE": {
        return Object.assign({}, state, { microSite: action.microSite });
      }
      case "MICROSITE_FRONTPAGE": {
        return Object.assign({}, state, {
          microSiteFrontPage: action.microSiteFrontPage,
        });
      }
      case "SEARCH_OPEN": {
        return Object.assign({}, state, { searchOpen: action.searchOpen });
      }
      case "PERSIST_VIEW_SWITCH": {
        return Object.assign({}, state, { persistViewSwitch: action.persistViewSwitch });
      }
      case "IS_CONFERENCE_OVERVIEW_PAGE": {
        return Object.assign({}, state, { isConferenceOverviewPage: action.isConferenceOverviewPage });
      }
      case "IS_FESTIVAL_OVERVIEW_PAGE": {
        return Object.assign({}, state, { isFestivalOverviewPage: action.isFestivalOverviewPage });
      }
      case "OVERWRITE_FOOTER": {
        return Object.assign({}, state, { overwriteFooter: action.overwriteFooter });
      }
      case "CUSTOM_HISTORY": {
        return Object.assign({}, state, { customHistory: action.customHistory });
      }
      case "SIMPLE_DESIGN": {
        return Object.assign({}, state, { simpleDesign: action.simpleDesign });
      }
      case "PANIC_SCROLL_BLOCK": {
        return Object.assign({}, state, { panicScrollBlock: action.panicScrollBlock });
      }
      case "PREVENT_JUMP_TO_CURRENT_TIME": {
        return Object.assign({}, state, { preventJumpToCurrentTime: action.preventJumpToCurrentTime });
      }

      default:
        return state;
    }
  };

export { appReducerDefaultState, appReducer };
